import { useContext, useEffect, useState } from "react";
import "./index.css";
import Accordion from "react-bootstrap/Accordion";
import DommusSidenavSection from "../DommusSidenavSection";
import { Icon } from "@iconify/react";
import infoCircleOutlined from "@iconify-icons/ant-design/info-circle-outlined";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { ListGroup } from "react-bootstrap";
import { CentralAjudaService } from "../../services/CentralAjudaService";
import { AppContext } from "../../contexts/AppContext";
import { TenhoUmProblema } from "../CentralAjuda/TenhoUmProblema";
import MinhasSolicitacoes from "../CentralAjuda/MinhasSolicitacoes";
import { DommusBtnAtendimentoChat } from "../CentralAjuda/TenhoUmProblema/ConversaAtendente/DommusBtnAtendimentoChat";
import { ChatAtendenteContext } from "../../contexts/ChatAtendenteContext";

export function Principal() {
    const { authToken, setUserData, openSideBar, setOpenSiderBar } =
        useContext(AppContext);
    const { openBtnChat } = useContext(ChatAtendenteContext);

    const showMenu = () => setOpenSiderBar((current) => !current);

    const [validAccess, setValidAccess] = useState(false);

    const sideHeader = (
        <div className="w-100 d-flex justify-content-between">
            <div style={{ marginTop: "0.5rem" }}>Central de Ajuda</div>
        </div>
    );

    useEffect(() => {
        if (!!authToken) {
            CentralAjudaService.validateToken(authToken)
                .then((response) => {
                    setUserData({
                        nome: response.data.usuario.nome,
                        email: response.data.usuario.email,
                        bloquear_sistema:
                            response.data.usuario.bloquear_sistema,
                    });
                    setValidAccess(true);
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            setValidAccess(false);
        }
    }, [authToken, setUserData]);

    return (
        <>
            <picture
                className="picture-topo infoCircleOutlined"
                onClick={showMenu}
            >
                <Icon
                    icon={infoCircleOutlined}
                    width="30"
                    data-tip
                    data-for="centralAjuda"
                />
                <ReactTooltip id="centralAjuda" place="top">
                    Central de Ajuda
                </ReactTooltip>
            </picture>

            <DommusSidenavSection
                openSection={openSideBar}
                closePaneHandler={showMenu}
                sectionHeader={sideHeader}
            >
                {validAccess ? (
                    <div>
                        <Accordion>
                            {/* <TenhoUmProblema eventKey={"1"} /> */}
                            {/* <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    Preciso de orientação:
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ListGroup>
                                        <ListGroup.Item>
                                            Em Desenvolvimento
                                        </ListGroup.Item>
                                    </ListGroup>
                                </Accordion.Body>
                            </Accordion.Item> */}
                            <MinhasSolicitacoes eventKey={"3"} />
                            {/* <Accordion.Item eventKey="4">
                                <Accordion.Header>
                                    Consultoria & treinamento:
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ListGroup>
                                        <ListGroup.Item>
                                            Em Desenvolvimento
                                        </ListGroup.Item>
                                    </ListGroup>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>
                                    Compartilhe sua experiência (Fórum Dommus):
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ListGroup>
                                        <ListGroup.Item>
                                            Em Desenvolvimento
                                        </ListGroup.Item>
                                    </ListGroup>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>
                                    Novidades (#fiquepordentro):
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ListGroup>
                                        <ListGroup.Item>
                                            Em Desenvolvimento
                                        </ListGroup.Item>
                                    </ListGroup>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="7">
                                <Accordion.Header>
                                    Versões/Roadmap:
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ListGroup>
                                        <ListGroup.Item>
                                            Em Desenvolvimento
                                        </ListGroup.Item>
                                    </ListGroup>
                                </Accordion.Body>
                            </Accordion.Item> */}
                        </Accordion>
                    </div>
                ) : (
                    <div>
                        <p>Verifique o login ou atualize a página</p>
                    </div>
                )}
            </DommusSidenavSection>
            {openBtnChat && <DommusBtnAtendimentoChat />}
        </>
    );
}
